import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormBuilderFielditemComponent } from '../components/form-builder-fielditem/form-builder-fielditem.component';
import { BaseForm } from './baseForm';

@Component({
  template: ''
})

export abstract class BuyerInfoStep extends BaseForm implements OnInit, AfterViewInit {
  stepForm!: FormGroup;
  @ViewChild(FormBuilderFielditemComponent) FormBuilder!: FormBuilderFielditemComponent;

  constructor(public fb: FormBuilder,) { super(); }

  ngOnInit() {
    this.stepForm = new FormGroup({
      buyerInfos: new FormControl([])
    });

    this.fromControllers = this.stepForm;
    this.stepForm.markAsUntouched();
  }
  ngAfterViewInit() {
    this.addBuyerInfosInitialValues();
  }

  addBuyerInfosInitialValues() {
    this.FormBuilder.formFieldControls;
    this.FormBuilder.onSave();
  }

  addingFormBuilderStep(formBuilderValue: any) {
    const formBuilderStep: any[] = [];
    formBuilderValue.ctrls.forEach((ctrl: any) => {
      if (ctrl.fieldLabel && ctrl.fieldTypes) {
        formBuilderStep.push(
          {
            id: ctrl.id,
            fieldName: ctrl.fieldLabel.trim(),
            fieldType: ctrl.fieldTypes,
            value: ctrl.selectionGroup ? ctrl.selectionGroup.option : [],
            fieldRequired: ctrl.fieldRequired
          }
        );
      }
    });
    this.stepForm.controls['buyerInfos'].setValue(formBuilderStep);
  }

  populateBuyerInfoFields(productObject: any) {
    let buyerInfos: any[] = [];
    productObject.BuyerInfoFields.forEach((field: any) => {
      if (field.name != 'Name' && field.name != 'Email' && field.name != 'Phone' && !field.isDeleted) {
        let fieldIsRequired = field.fieldRequired ? true : false;
        let options: any[] = [];
        let controlOptions: any[] = [];
        field.BuyerInfoFieldOptions.forEach((option: any) => {
          if (!option.isDeleted && option.name && option.name != "") {
            options.push({ id: option.id, name: option.name });
            controlOptions.push(this.fb.group({
              id: this.fb.control(option.id || ''),
              name: this.fb.control(option.name || '')
            }));
          }
        });
        buyerInfos.push({
          id: field.id || '',
          fieldLabel: field.name,
          fieldTypes: field.FieldTypeId,
          fieldRequired: fieldIsRequired,
          selectionGroup: {
            option: options
          }
        });
        this.FormBuilder.formFieldControls.push(this.fb.group({
          id: this.fb.control(field.id || ''),
          fieldTypes: this.fb.control(field.FieldTypeId, [Validators.required]),
          fieldLabel: this.fb.control(field.name, [Validators.required]),
          fieldRequired: this.fb.control(fieldIsRequired),
          selectionGroup: this.fb.group({
            option: this.fb.array(controlOptions)
          }),
        }));
      }
    });
    this.FormBuilder.onSave()
    let mappedBuyerInfoObject = {
      ctrls: buyerInfos
    }
    this.addingFormBuilderStep(mappedBuyerInfoObject);
  }

}
